import { CONTROL_PANEL_TOGGLE_HEADER,
          CONTROL_PANEL_SHOW_HEADER,
          CONTROL_PANEL_HIDE_HEADER
} from "./actionType";

const initialState = {
    isHeaderVisible: true,
}

const controlPanelReducer = (state = initialState, action) => {
    switch (action.type) {
        case CONTROL_PANEL_TOGGLE_HEADER:
            return {
                ...state,
                isHeaderVisible: !state.isHeaderVisible,
            };
        case CONTROL_PANEL_SHOW_HEADER:
            return {
                ...state,
                isHeaderVisible: true,
            };
        case CONTROL_PANEL_HIDE_HEADER:
            return {
                ...state,
                isHeaderVisible: false,
            };
        default:
            return state;
    }
};

export default controlPanelReducer;